import { render, staticRenderFns } from "./SocialPostCommentEditor.vue?vue&type=template&id=e78b5abc&"
import script from "./SocialPostCommentEditor.vue?vue&type=script&lang=js&"
export * from "./SocialPostCommentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e78b5abc')) {
      api.createRecord('e78b5abc', component.options)
    } else {
      api.reload('e78b5abc', component.options)
    }
    module.hot.accept("./SocialPostCommentEditor.vue?vue&type=template&id=e78b5abc&", function () {
      api.rerender('e78b5abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialPostCommentEditor.vue"
export default component.exports